import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { themes, getThemeCSSVariables } from './themeConfig';

const ThemeProvider = ({ children }) => {
  const theme = useSelector((state) => state.ui.theme);
  const currentTheme = themes[theme] || themes.dark;
  const cssVariables = getThemeCSSVariables(currentTheme);

  useEffect(() => {
    // Apply CSS variables to :root
    const root = document.documentElement;
    
    Object.entries(cssVariables).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });

    // Apply body styles
    document.body.style.fontWeight = currentTheme.typography.fontWeight;
    document.body.style.color = currentTheme.colors.text;
    document.body.style.background = currentTheme.colors.bg;
    document.body.style.fontFamily = "'Poppins', sans-serif";
    
    // Apply font size
    document.body.style.fontSize = currentTheme.typography.fontSize;

    // LIGHT THEME: Apply bold class for elderly readability
    if (theme === 'light') {
      document.body.classList.add('light-theme-bold');
      // Force all text to be bolder and darker
      document.body.style.fontWeight = '700';
    } else {
      document.body.classList.remove('light-theme-bold');
      document.body.style.fontWeight = currentTheme.typography.fontWeight;
    }

    // Set data attribute for CSS selectors
    root.setAttribute('data-theme', theme);
    
  }, [theme, cssVariables, currentTheme]);

  return <>{children}</>;
};

export default ThemeProvider;